export const roles = {
    Owner: {
        allCapabilities: true,
        can: [
            'adminusers/modify-admins'
        ]
    },
    Developer: {
        inherits: ['Editorial', 'Super-Moderator', 'Analyst']
    },
    'Super-Moderator': {
        inherits: ['Moderator']
    },
    Moderator: {
        can: [
            'remove-comment',
            'moderate'
        ]
    },
    Editorial: {
    },
    Analyst: {
        can: [
            'eventlog/view'
        ]
    }
};

export const newRoles = {
    Owner: {
    },
    Developer: {
        inherits: ['Editorial', 'Super-Moderator', 'Analyst'],
        can: ['features/toggle-experimental', 'developer/add-comments'],
        allCapabilities: true
    },
    'Super-Moderator': {
        inherits: ['Moderator'],
        can: ['moderation/edit-blocklist', "channel/create", "channel/edit", "channel/manage-members", "channel/access-all-channels"],
    },
    Moderator: {
        can: ['moderation/judge', 'moderation/view', 'moderation/view-blocklist', "channel/view"],
    },
    Editorial: {
        can: [
            'features/toggle-stable',
            'content/questions',
            'content/topics',
            'content/video-votings',
            'admin/email-preview'
        ]
    },
    Analyst: {
        can: [
            'eventlog/view'
        ]
    }
};
